import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbAlertModule, NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from 'ng2-translate';
import { Material } from '../_shared/material.module';
import { RouterModule, Routes } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { SaveUsernameComponent } from './save-username/save-username.component';
import { AuthGuard } from '../_guards/auth.guard';
import { AuthActionsComponent } from './auth-actions/auth-actions.component';
import { AuthComponent } from './auth.component';
import { AgreementComponent } from '../directive/agreement/agreement.component';
import { AuthenticationService } from '../_services';
import { AuthProvidersComponent } from './register/auth-providers/auth-providers.component';
import { ApiService } from '../_services/api.service';
import { PhoneNumberAuthenticationComponent } from './phone-number-authentication/phone-number-authentication.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PhoneAuthenticationService } from '../_services/phone-authentication.service';
import { TextMaskModule } from 'angular2-text-mask';

const routes: Routes = [{
  path: '',
  data: {
    title: 'Register Page',
    urls: [{ title: 'Register Page' }]
  },
  children: [{
    path: '',
    component: RegisterComponent,
    pathMatch: "full"
  }, {
    path: 'saveUsername',
    component: SaveUsernameComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'action',
    component: AuthActionsComponent
  }, {
    path: 'phoneNumber',
    component: PhoneNumberAuthenticationComponent
  }],
  component: AuthComponent
}];
@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    NgbDatepickerModule,
    NgbAlertModule,
    TextMaskModule,
    NgbTabsetModule,
    TranslateModule,
    Material,
    RouterModule.forChild(routes)
  ],
  entryComponents: [AgreementComponent],
  declarations: [RegisterComponent, SaveUsernameComponent, AuthActionsComponent, AuthComponent, AuthProvidersComponent, AgreementComponent, PhoneNumberAuthenticationComponent],
  providers: [AuthenticationService, ApiService, PhoneAuthenticationService]
})
export class AuthModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/auth/auth.module.ts